// 循环滚动指令
/**
 * v-loop-scroll="{
    'data': tableData, //表单数据
    'pageSize': '20',  //每页数据大小
    'isTable': true, //是否el-table组件
    'loaded': (data， startIndex, endIndex)=>{  //加载回调
      loadPoint = data
    }
  }"
 */
export default {
  bind (el, binding, vnode) {

  },
  inserted (el, binding, vnode) {
    // 是否表格
    let isTable = true
    // 当前页数
    let pageNumber = 1
    // 最大页数
    let maxPageNumber = 1
    // 分页数量
    let pageSize = 20
    const value = binding.value
    if (value.pageSize) {
      pageSize = !isNaN(parseInt(value.pageSize)) ? parseInt(value.pageSize) : pageSize
    }
    const loadDataFunc = value.loaded
    maxPageNumber = Math.ceil(value.data.length / pageSize)
    isTable = value.isTable !== false
    const onLoadData = function (startPage, endPage) {
      const startIndex = pageSize * (startPage - 1)
      const endIndex = pageSize * (endPage - 1)
      const data = value.data.slice(startIndex, endIndex)
      if (loadDataFunc) {
        loadDataFunc(data, startIndex, endIndex)
      }
      el.startIndex = startIndex
      el.endIndex = endIndex
    }
    const onScroll = function (event) {
      const dom = event.currentTarget
      // 滚动距离
      const scrollTop = dom.scrollTop
      // 变量windowHeight是可视区的高度
      const windowHeight = dom.clientHeight
      // 变量scrollHeight是滚动条的总高度
      const scrollHeight = dom.scrollHeight
      if (scrollTop + windowHeight === scrollHeight) {
        // 滚动到底
        if (pageNumber < maxPageNumber - 1) {
          pageNumber = pageNumber + 1
          if (pageNumber > maxPageNumber) {
            pageNumber = maxPageNumber
          }
          onLoadData(pageNumber, pageNumber + 1)
          dom.scrollTop = 1
        } else if (pageNumber === maxPageNumber - 1) {
          pageNumber = maxPageNumber - 1
          onLoadData(pageNumber, pageNumber + 2)
        }
      } else if (scrollTop === 0) {
        if (pageNumber <= 1) {
          return
        }
        // 滚动到顶
        pageNumber = pageNumber - 1
        if (pageNumber < 1) {
          pageNumber = 1
        }
        onLoadData(pageNumber, pageNumber + 1)
        if (pageNumber >= 1) {
          dom.scrollTop = scrollHeight - windowHeight - 1
        }
      }
    }

    if (isTable) {
      vnode.child.$refs.bodyWrapper.addEventListener('scroll', onScroll)
      el.container = vnode.child.$refs.bodyWrapper
    } else {
      vnode.elm.addEventListener('scroll', onScroll)
      el.container = vnode.elm
    }

    el.onScroll = onScroll
    el.onLoadData = onLoadData
    onLoadData(pageNumber, pageNumber + 1)
  },
  componentUpdated (el, binding, vnode) {
    // const data = binding.value.data
    // const oldData = binding.oldValue.data
  },
  unbind (el, binding, vnode) {
    const { container, onScroll } = el
    if (container) {
      container.removeEventListener('scroll', onScroll)
    }
  }
}
